import { SET_MODEL_NAME } from './names';

export const setModelName = modelName => ({
  type: SET_MODEL_NAME,
  modelName,
});
